import sneakersImg from '../../assets/images/pedometer/permission-sneakers.png';
import infoIcon from '../../assets/images/pedometer/permission-info.svg';

export const PEDOMETER_CONSENT_SEEN_KEY = 'playground-pedometer-consent-seen';

export function isPedometerConsentSeen() {
  try {
    return localStorage.getItem(PEDOMETER_CONSENT_SEEN_KEY) === '1';
  } catch (error) {
    return false;
  }
}

export function markPedometerConsentSeen() {
  try {
    localStorage.setItem(PEDOMETER_CONSENT_SEEN_KEY, '1');
  } catch (error) {
    // ignore quota / private mode
  }
}

/**
 * 만보기 최초 권한 안내 하단 시트 (Figma 만보기_팝업01 · 1994:12704)
 */
export default function PedometerPermissionSheet({ open, onAllow, onDisagree }) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[112] flex items-end justify-center bg-black/80"
      role="dialog"
      aria-modal="true"
      aria-label="만보기 권한 안내"
    >
      <div className="relative w-full max-w-[500px] rounded-t-2xl bg-white pb-8 pt-5 shadow-lg">
        {/* Figma Line 41 — 상단 핸들 */}
        <div className="mx-auto mb-[44px] h-0.5 w-9 rounded-full bg-[#D9D9D9]" aria-hidden="true" />

        <div className="mx-auto flex w-[calc(100%-20px)] max-w-[340px] flex-col items-center gap-[30px]">
          <div className="flex w-full items-start gap-2.5">
            <div className="size-[120px] shrink-0 overflow-hidden rounded-full">
              <img
                src={sneakersImg}
                alt=""
                className="size-full object-cover object-center"
              />
            </div>
            <div className="flex w-[201px] min-w-0 flex-col gap-2.5 tracking-[-0.3px]">
              <p className="font-['Pretendard'] text-2xl font-bold leading-[1.4] text-black">
                걸음 수를 기록하고
                <br />
                보상도 놓치지 마세요
              </p>
              <p className="font-['Pretendard'] text-base font-bold leading-[1.5] text-[#8B68DD]">
                건강 앱(걸음) 권한을 허용하면 걸음 수가 자동으로 기록돼요.
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col gap-2.5">
            <div className="flex items-center justify-center rounded-[10px] bg-[#E2E6FF] py-[30px]">
              <div className="flex max-w-[294px] items-start gap-2.5 px-1">
                <img src={infoIcon} alt="" className="size-[23px] shrink-0" />
                <p className="font-['Pretendard'] text-sm font-bold leading-[1.5] tracking-[-0.3px] text-[#5E5E5E]">
                  권한을 허용하지 않으면 걸음 수가 집계되지 않아,
                  만보기 보상을 받거나 관련 이벤트에
                  참여할 수 없어요.
                </p>
              </div>
            </div>

            <div className="flex w-full flex-col gap-2.5">
              <button
                type="button"
                className="flex h-[54px] w-full items-center justify-center rounded-2xl border-0 bg-gradient-to-b from-[#3B5CD2] to-[#8B68DD] font-['Pretendard'] text-lg font-bold leading-[1.5] tracking-[-0.3px] text-white outline-none"
                onClick={onAllow}
              >
                권한 허용하기
              </button>
              <button
                type="button"
                className="flex h-[54px] w-full items-center justify-center rounded-2xl border-0 bg-[#F4F4F4] font-['Pretendard'] text-lg font-bold leading-[1.5] tracking-[-0.3px] text-[#919191] outline-none"
                onClick={onDisagree}
              >
                권한 비동의
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
